<template>
	<div class="selectvip">
		<el-row>
			<el-col :span="16"><span class="remark">勾选/取消勾选 即可增减人员</span></el-col>
			<el-col :span="8">
				<el-input v-model="searchbox" @keyup.enter.native="refreshgrid(true)" placeholder="可按账号\姓名\会员卡搜索" size="small" class="input-with-select">
					<el-button slot="append" size="mini">搜索</el-button>
				</el-input>
			</el-col>
		</el-row>
		<el-row style="margin-top:10px;">
			<el-col>
				<tableui
					v-loading="loading"
					ref="viplist"
					:tableData="userlist"
					:columns="columns"
					:gridheight="gridheight"
					editcell="0"
					@checkboxchange="checkboxchange"
					@gridscroll="gridscroll" 
					:istop="istop"
				></tableui>
			</el-col>
		</el-row>
		<el-row>
			<el-col>共{{ count }}条数据</el-col>
		</el-row>
	</div>
</template>
<script>
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	props: {
		// c_id: {
		// 	type: String,
		// 	defualt: ''
		// }
	},
	data() {
		return {
			istop:false,
			loading: false,
			pagesize: 200,
			pageindex: 0,
			gridheight: (window.innerHeight * 50) / 100 - 30 + 'px',
			columns: [],
			userlist: [],
			count: 0,
			pagecount: 0,
			sortcol: '', //列表排序
			selectedall: false,
			checkedrow: {},
			isadd: false ,//是否新增报价方案
			searchbox:'',
			mode:'会员列表',
			cid:'',
			p_mode:'',
			p_type:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/user.scss');
		});
		this.cid=this.c_id;
		this.GetColumns();
		this.gridscroll();
	},
	methods: {
		GetColumns() {
			var that = this;
			if(this.columns.length>0){
				that.refreshgrid(true);
			}else{
				this.$apipost.get.GetColumns({ tab:'', checkfield: 1, parentid:-1, mode: this.mode }).then(res => {
					that.columns = res;
					that.refreshgrid(true);
				});
			}
			
		},
		checkboxchange(e) {
			this.checkedrow = e.row;
			this.isadd = e.selected;
			this.selectedall = e.selectedall;
			this.setviptocw();
		},
		//滚动加载列表
		//滚动加载列表
		gridscroll(e) {
			if(e!=undefined){
				var that = this;
				const scrollDistance = e.event.target.scrollHeight -e.e.scrollTop-e.event.target.offsetHeight;
				if (scrollDistance <=82) {
					that.refreshgrid(false);
				}
			}
		},
		//设置勾选用户的计费方案 1/2
		setviptocw() {
			var that=this;
			this.$tool.loading('正在设置', 'selectvip');
			var vipaccount = '';
			if (this.selectedall) {
				//全选
				this.isadd=true;
				var paraminfo={
						mode:this.mode,
						tab:'',
						search: this.GetSearchObj(),
						pageindex:0,
						pagesize: 0,
						sort: this.sort,
						iscount:1,
						showcol: JSON.stringify(this.columns),
					}
				this.$apipost.get
					.GetGridTable({paraminfo:paraminfo})
					.then(res => {
						res.data.forEach(e => {
							vipaccount += e.vipaccount + ',';
						});
						if (vipaccount != '') {
							vipaccount = vipaccount.substring(0, vipaccount.length - 1);
							that.setviptocw2(vipaccount);
						} else {
							this.$tool.loadingclose();
							this.$tool.message('获取会员失败，请重试', 0);
						}
					});
			} else {
				debugger
				vipaccount = this.checkedrow.vipaccount;
				if(vipaccount==undefined){
					this.isadd=false;
					vipaccount="";
				}
					
				if (vipaccount != undefined) {
					this.setviptocw2(vipaccount);
				}
			}
		},
		//设置勾选用户的计费方案 2/2
		setviptocw2(vipaccount) {
			var that=this;
			if(this.p_type=='成本价'&&this.isadd){
				this.$tool.loadingclose();
				this.$confirm('设置为此方案类型将清除此用户原来所有的财务方案，确定要操作吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: true
				}).then(() => {
					this.$tool.loading('正在设置', 'selectvip');
					that.setviptocw3(vipaccount);
				});
			}else{
				this.setviptocw3(vipaccount);
			}
		},
		setviptocw3(vipaccount){
			var that=this;
			var paraminfo={
				vipaccount: vipaccount,
				 c_id: this.cid, 
				 isadd: this.isadd,
				 p_mode:this.p_mode,
				 p_type:this.p_type,
				 handleaccount:localStorage.getItem('u_account')
			}
			debugger
			this.$apipost.post.SetViptocw({paraminfo:paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('设置成功', 1);
				} else {
					this.$tool.message(res.message, 0);
					that.setgridchecked(!that.isadd,vipaccount);
				}
			});
		},
		GetSearchObj(){
			var searchinfo={
				searchbox:this.searchbox
			}
			return searchinfo;
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			this.istop=false;
			if (isrefresh) {
				//刷新
				that.pageindex = 0;
				this.istop=true;
				this.selectedall=false;
				this.checkedrow=[];
			} else {
				//加载下一页
				if (that.pagecount - 1 > that.pageindex) {
					that.pageindex = that.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				var paraminfo={
						mode:this.mode,
						tab:'',
						search: this.GetSearchObj(),
						pageindex: this.pageindex,
						pagesize: this.pagesize,
						sort: this.sort,
						iscount:1,
						showcol: JSON.stringify(this.columns),
					}
				that.loading = true;
				this.$apipost.get
					.GetGridTable({paraminfo:paraminfo})
					.then(res => {
						that.loading = false;
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.userlist = that.userlist.concat(res.data);
							} else {
								that.userlist = res.data;
							}
						}
						that.setgriddefault(that.userlist);
						that.pagecount = res.pagecount;
						that.count = res.count;
					});
			}
		},
		//初始化
		init(param) {
			debugger
			this.cid = param.c_id;
			if(param.p_mode!=undefined)
				this.p_mode=param.p_mode;
			if(param.p_type!=undefined)
				this.p_type=param.p_type;	
			this.userlist = [];
			this.pageindex = 0;
			this.pagecount = 0;
			this.GetColumns();
		},
		//设置列表默认值,加载数据时调用
		setgriddefault(data) {
			var that = this;
			var c_id = this.cid;
			this.$nextTick(() => {
			    data.forEach(row => {
					if(row.c_id!=null){
						if(row.c_id.indexOf(c_id+',')>-1){
							that.$refs.viplist.$children[0].toggleRowSelection([{row:row, selected:true}]);
						}
					}
			  })
			});
		},
		setgridchecked(selected,vipaccount){
			var that = this;
			var data=that.userlist;
			var vips=vipaccount.split(',');
			this.$nextTick(() => {
			    data.forEach(row => {
					if(row.vipaccount!=null){
						vips.forEach(v=>{
							if(row.vipaccount==v){
								that.$refs.viplist.$children[0].toggleRowSelection([{row:row, selected:selected}]);
							}
						});
						}
					});
				});
		}
	}
};
</script>
